import React from "react";
import { toggle } from "../../../../util/common";
import LegalFilingsSummary from "./LegalFilingsSummary";
import LegalFilingsActiveTaxLines from "./LegalFilingsActiveTaxLines";
import LegalFilingsActiveJudgements from "./LegalFilingsActiveJudgements";
import LegalFilingsActiveLawsuits from "./LegalFilingsActiveLawsuits";
import LegalFilingsUccFilings from "./LegalFilingsUccFilings";
import { BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const LegalFilings: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    {props.showAsAccordion ? (
                        <button
                            aria-expanded="false"
                            className="btn-default btn-toggle btn-drawer"
                            id="btn-legal-filings"
                            onClick={() => toggle("legal-filings-div", "btn-legal-filings")}
                        >
                            <span className="btn-toggle-status sr-only">Show</span>
                            <span className="btn-text">Legal Filings</span>
                        </button>
                    ) : (
                        <h3>Legal Filings</h3>
                    )}
                </div>

                <div className="drawer-content" id="legal-filings-div" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}>
                    <div role="list" className="data-grid has-lines margin-top-s" id="">
                        <LegalFilingsSummary reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        <LegalFilingsActiveTaxLines reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        <LegalFilingsActiveJudgements reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        <LegalFilingsActiveLawsuits reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        <LegalFilingsUccFilings reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LegalFilings;
